<template>
	<div
		class="fixed z-10 inset-0 overflow-y-auto"
		aria-labelledby="modal-title"
		role="dialog"
		aria-modal="true"
	>
		<div
			class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
		>
			<transition name="fade">
				<div
					class="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity"
					aria-hidden="true"
					v-if="open"
					ref="overlay"
					v-on:click="close()"
				></div>
			</transition>

			<!-- This element is to trick the browser into centering the modal contents. -->
			<span
				class="hidden sm:inline-block sm:align-middle sm:h-screen"
				aria-hidden="true"
				>&#8203;</span
			>

			<transition name="zoomin">
				<div
					class="inline-block align-middle bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full md:max-w-screen-md"
				>
					<!-- header -->
					<slot name="header">
						<div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
							<button
								type="button"
								class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
								v-on:click="close()"
							>
								<span class="sr-only">{{ __("Close") }}</span>
								<ui-icon name="x" class="h-6 w-6" stroke-width="2" />
							</button>
						</div>
					</slot>

					<slot name="full-content">
						<div class="p-6">
							<div class="sm:flex sm:items-start">
								<div class="mt-4 text-center sm:mt-0 sm:ml-4 sm:text-left">
									<h2 class="text-3xl font-semibold text-gray-900">
										Profilstatus
									</h2>
									<p class="my-4">
										Anhand der Schritte im Profilstatus erkennen Sie Ihren
										Fortschritt auf cropspot. Nach Abschluss aller Stufen sehen
										Sie Ihren Erfolg im Vermarktungs-Dashboard.
									</p>
									<ol class="relative mt-4">
										<li
											class="pb-4 border-l-4 border-orange pl-12"
											style="margin-left: 20px"
										>
											<span
												class="flex absolute justify-center items-center bg-orange rounded-full left-4"
												style="width: 16px; height: 16px"
											>
											</span>
											<h3
												class="mb-2 text-lg font-semibold text-gray-900 dark:text-white leading-4"
											>
												Anfänger
											</h3>
											<p
												class="pb-2 text-base font-normal text-gray-500 dark:text-gray-400"
											>
												Das ist der Grundstatus für alle Nutzer. Sobald Sie Ihr
												erstes Inserat erstellt und an einer Verhandlung
												teilgenommen haben, erreichen Sie den Profilstatus
												"Mittel".
											</p>
										</li>
										<li
											class="pb-4 border-l-4 border-orange pl-12"
											style="margin-left: 20px"
										>
											<span
												class="flex absolute justify-center items-center bg-orange rounded-full left-4"
												style="width: 16px; height: 16px"
											>
											</span>
											<h3
												class="mb-2 text-lg font-semibold text-gray-900 dark:text-white leading-4"
											>
												Mittel
											</h3>
											<p
												class="pb-2 text-base font-normal text-gray-500 dark:text-gray-400"
											>
												Der Profilstatus "Mittel" bringt Ihnen relevantere
												Vermarktungsinformationen und gezielte Preisvorschläge.
												Sie müssen ein Inserat erstellen und an einer
												Verhandlung teilnehmen, um diesen Status zu erreichen.
											</p>
										</li>
										<li
											class="pb-4 border-l-4 border-white pl-12"
											style="margin-left: 20px"
										>
											<span
												class="flex absolute justify-center items-center bg-orange rounded-full left-4"
												style="width: 16px; height: 16px"
											>
											</span>
											<h3
												class="mb-2 text-lg font-semibold text-gray-900 dark:text-white leading-4"
											>
												Profi
											</h3>
											<p
												class="pb-2 text-base font-normal text-gray-500 dark:text-gray-400"
											>
												Mit min. einem abgeschlossenen Kontrakt und einem
												Überblick über das Dashboard erreichen Sie den
												Profilstatus "Profi"
											</p>
										</li>
									</ol>
								</div>
							</div>
						</div>
					</slot>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			open: false,
		};
	},
	mounted() {
		this.open = true;
	},
	methods: {
		close() {
			//this.$emit('close');
			let ref = this.$refs.overlay,
				that = this;
			setTimeout(function () {
				that.$emit("close");
			}, 300);
			this.$nextTick(function () {
				this.open = false;
			});
		},
	},
};
</script>
